import BaseView from '../../../views/base';
import SelectBoxTemplate from '../templates/selectBox.html';

const SelectView = BaseView.extend({
    events: {
        'input .js-select-library-autocomplete': 'filterShownLibraries',
        'focus .js-select-library-autocomplete': 'onSelectFocus',
        'blur .js-select-library-autocomplete': 'onSelectBlur',
        'click .js-clear-input': 'clearInput',
        'keydown .js-clear-input': 'clearInput',
    },

    initialize({ target, model, collection }) {
        this.target = target;
        this.model = model;
        this.libraries = collection;
        this.template = SelectBoxTemplate;
        this.listenTo(this.libraries, 'sync', this.maybeRender);
    },

    onSelectFocus() {
        this.$('.js-select-library-autocomplete')
            .addClass('is-focused')
            .removeClass('is-blur');
    },

    onSelectBlur() {
        this.$('.js-select-library-autocomplete')
            .removeClass('is-focused')
            .addClass('is-blur');
    },

    filterShownLibraries(evt) {
        const currentVal = $(evt.target).val().toLowerCase().replace(/ /g, '');
        const $noMatchesFound = this.$el.find('.js-no-matches-found');

        if (currentVal === '') {
            $('.js-branch').show();
            $('.js-clear-input').hide();
            $noMatchesFound.hide();
        } else {
            $('.js-branch').hide();
            $(`.js-branch[class*="${currentVal}"]`).show();
            $('.js-clear-input').show();

            if (!$(`.js-branch[class*="${currentVal}"]`).length) {
                $noMatchesFound.show();
            } else {
                $noMatchesFound.hide();
            }
        }
    },

    isSelectEvent(e) {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            return true;
        }
        return false;
    },

    clearInput(e) {
        if (!this.isSelectEvent(e)) {
            return;
        }
        $('.js-select-library-autocomplete').val('');
        $('.js-branch').show();
        $('.js-clear-input').hide();
        this.$el.find('.js-no-matches-found').hide();
        $('.js-select-library-autocomplete').focus();
    },

    getTemplateData() {
        return {
            members: this.libraries.models,
        };
    },

    maybeRender() {
        if (this.libraries.models.length) {
            this.render();
        }
    },

    onClose() {
        this.undelegateEvents();
        this.target.removeData().unbind();
        this.target.empty();
    },
});

export default SelectView;
